import moment from 'moment-timezone';
import styles from '../css/widgetButton.css';
import { createEl, createBtn, removeClass } from '../helpers/domHelpers';
import { onButtonClick } from '../helpers/analytics'
import { widgetCtrl as ctrl } from '../widgetController';

const widgetButton = {
  init() {
    // /////////////
    // / Elements ///
    // //////////////

    this.buttonContainer = createBtn(`${styles.container} open-chair-widget___button`);

    this.icon = createEl('img', styles.icon, '', { src: require('../../assets/cal-icon-light.png') });
    this.indicator = createEl('div', styles.indicatorDot);
    this.button = createEl('div', styles.button);
    this.button.append(this.indicator, this.icon);

    this.buttonExpand = createEl('div', styles.expand);
    this.indicatorText = createEl('span', styles.indicatorText, '');
    this.buttonText = createEl('span', styles.mainText, 'Schedule Consultation');
    this.buttonExpand.append(this.indicatorText, this.buttonText);
    this.buttonContainer.append(
      this.buttonExpand,
      this.button,
    );

    // TODO: test/adjust on mobile/add touch events - make sure it works
    // ///////////////
    // // Listeners ///
    // ////////////////
    let expandTimeout;
    this.buttonContainer.addEventListener('click', onButtonClick);
    this.buttonContainer.addEventListener('mouseenter', () => {
      expandTimeout = this.handleExpandButton(250);
      // Google Analytics:
      if (process.env.NODE_ENV === 'production') {
        ga('openchair.send', {
          hitType: 'event',
          eventCategory: 'Button',
          eventAction: 'hover',
        });
      }
    });

    this.buttonContainer.addEventListener('mouseleave', () => {
      this.handleCollapseButton(expandTimeout);
    });

    this.render();

    return this.buttonContainer;
  },

  handleExpandButton(wait) {
    this.buttonContainer.className += ` ${styles.hover}`;
    this.button.style.borderWidth = '1px';
    return setTimeout(() => {
      this.buttonExpand.style.opacity = '1';
    }, wait);
  },

  handleCollapseButton(timeout) {
    clearTimeout(timeout);
    removeClass(this.buttonContainer, styles.hover);
    this.button.style.borderWidth = '0px';
    this.buttonExpand.style.opacity = '0';
  },

  render() {
    const available = ctrl.getNumberBookingsAvailable();
    if (available.length) {
      this.indicator.textContent = available.length;
      this.indicatorText.textContent = `${available.length} Spot${available.length > 1 ? 's' : ''} Available This Week!`;
    } else {
      this.indicator.style.display = 'none';
    }

    this.handleExpandButton(0);
    setTimeout(() => {
      this.handleCollapseButton();
    }, 15000);
  },

};

export default widgetButton;



// WEBPACK FOOTER //
// ./src/views/widgetButton.js